// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"AppContainer__wrapper___3Niv9","container":"AppContainer__container___3ZdNU","fixedBackground":"AppContainer__fixedBackground___1D4WB"};